<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
      <div class="modal-header">Création d'une consultation</div>
      <div class="modal-body" *ngIf="formGroup">

        <frg-form-input
          id="consultationTitle"
          type="text"
          label="Titre de la consultation"
          [formGroup]="formGroup"
          [control]="formGroup.get('consultationTitle')"
        ></frg-form-input>

        <frg-form-input
          id="consultationDate"
          type="date"
          [selectValue]="profilResources"
          label="Date de la consultation"
          [formGroup]="formGroup"
          [control]="formGroup.get('consultationDate')"
        ></frg-form-input>

        <frg-form-input
          id="consultationType"
          type="ngSelect"
          label="Type de la consultation"
          [formGroup]="formGroup"
          [control]="formGroup.get('consultationType')"
          [selectValue]="typeConsultationSelectList"
        ></frg-form-input>
      </div>
      <div class="button-wrapper" *ngIf="formGroup">
        <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
        <frg-button (activated)="createConsultation()" [disabled]="!formGroup.valid">Valider</frg-button>
      </div>
    </div>
  </div>
  <div class="modal-background"></div>